export default __webpack_public_path__ + "static/media/htyc.0aeebd0d.jpg";